import { Alert, Button, Form, Input } from 'antd';
import { useNameEdit } from '../hooks/use-name-edit';
import { ProfileRow } from './ProfileRow';

export function NameRow({ name }: { name: string }) {
  const { isEditing, error, submitting, edit, save, cancel } = useNameEdit();

  return (
    <ProfileRow
      label="Name"
      value={name}
      action={
        !isEditing && (
          <Button size="small" onClick={edit}>
            Edit
          </Button>
        )
      }
    >
      {isEditing && (
        <div className="mt-3 max-w-sm">
          {error && <Alert className="mb-3" type="error" title={error} showIcon />}
          <Form<{ name: string }>
            layout="vertical"
            requiredMark={false}
            initialValues={{ name }}
            onFinish={(values) => save(values.name)}
            disabled={submitting}
          >
            <Form.Item name="name" label="Your name" rules={[{ required: true, whitespace: true, message: 'Enter your name' }]}>
              <Input autoFocus autoComplete="name" maxLength={120} />
            </Form.Item>
            <div className="flex gap-2">
              <Button type="primary" htmlType="submit" loading={submitting}>
                Save
              </Button>
              <Button onClick={cancel} disabled={submitting}>
                Cancel
              </Button>
            </div>
          </Form>
        </div>
      )}
    </ProfileRow>
  );
}
